import { Rol } from '@shared/models/notificaciones/Rol';

export class Asignacion {
  id!: string;
  nombreAsignacion: string;
  rolesSolicitantes: Rol[];
  rolesAprobadores: Rol[];
}